module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_engl_sekundaerlogo_postale_pos.65f0f1e2.pdf";